export default "__VITE_ASSET__CQ12p0jW__"